import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, Grid, Palette, Code, Video, Sparkles, Layers } from 'lucide-react';
import { useTheme } from '../App';
interface MobileFilterDropdownProps {
  categories: string[];
  activeCategory: string;
  onSelectCategory: (category: string) => void;
}
// Icon mapping for categories
const getCategoryIcon = (category: string) => {
  const iconMap: Record<string, any> = {
    All: Grid,
    Design: Palette,
    Development: Code,
    Video: Video,
    Art: Sparkles,
    Web: Layers
  };
  const Icon = iconMap[category] || Grid;
  return <Icon className="w-4 h-4" data-id="element-156" />;
};
export function MobileFilterDropdown({
  categories,
  activeCategory,
  onSelectCategory
}: MobileFilterDropdownProps) {
  const [isOpen, setIsOpen] = useState(false);
  const {
    theme
  } = useTheme();
  const isDark = theme === 'dark';
  const handleSelect = (category: string) => {
    onSelectCategory(category);
    setIsOpen(false);
  };
  return <div className="relative w-full mb-4" data-id="element-157">
      {/* Dropdown Button - Shorter height */}
      <button onClick={() => setIsOpen(!isOpen)} className={`w-full px-5 py-3 rounded-xl border-2 flex items-center justify-between transition-all duration-300 ${isDark ? 'bg-black border-white/10 text-white hover:border-white/20' : 'bg-white border-black/10 text-black hover:border-black/20'}`} data-id="element-158">
        <div className="flex items-center gap-2" data-id="element-159">
          {getCategoryIcon(activeCategory)}
          <span className="font-medium" data-id="element-160">{activeCategory}</span>
        </div>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3
      }} data-id="element-161">
          <ChevronDown className="w-5 h-5" data-id="element-162" />
        </motion.div>
      </button>

      {/* Dropdown Menu */}
      <AnimatePresence data-id="element-163">
        {isOpen && <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -10
      }} transition={{
        duration: 0.2
      }} className={`absolute top-full left-0 right-0 mt-2 rounded-xl border-2 overflow-hidden z-50 ${isDark ? 'bg-black border-white/10' : 'bg-white border-black/10'}`} data-id="element-164">
            <div className="max-h-64 overflow-y-auto" data-id="element-165">
              {categories.map(category => <button key={category} onClick={() => handleSelect(category)} className={`w-full px-5 py-2.5 text-left transition-all duration-200 flex items-center gap-2 ${category === activeCategory ? isDark ? 'bg-white/10 text-white font-medium' : 'bg-black/5 text-black font-medium' : isDark ? 'text-white/60 hover:bg-white/5 hover:text-white' : 'text-black/60 hover:bg-black/5 hover:text-black'}`} data-id="element-166">
                  {getCategoryIcon(category)}
                  <span data-id="element-167">{category}</span>
                </button>)}
            </div>
          </motion.div>}
      </AnimatePresence>

      {/* Backdrop to close dropdown */}
      {isOpen && <div className="fixed inset-0 z-40" onClick={() => setIsOpen(false)} data-id="element-168" />}
    </div>;
}